import { useAuth } from '../context/AuthContext';

/**
 * Hook per verificare i permessi dell'utente su una sezione.
 * Restituisce canView (Read o ReadWrite) e canEdit (solo ReadWrite).
 */
export function usePermission(section: string) {
  const { canView, canEdit } = useAuth();
  return {
    canView: canView(section),
    canEdit: canEdit(section),
  };
}

/**
 * Costanti sezioni permessi — corrispondono al backend PermissionSections.
 */
export const Sections = {
  Dashboard: 'dashboard',
  PlantDetail: 'plant_detail',
  PlantSettings: 'plant_settings',
  Documents: 'documents',
  Trends: 'trends',
  Statistics: 'statistics',
  SynopticView: 'synoptic_view',
  SynopticEdit: 'synoptic_edit',
  AlarmsView: 'alarms_view',
  AlarmsManage: 'alarms_manage',
  Gateway: 'gateway',
  AlertRules: 'alert_rules',
  AdminUsers: 'admin_users',
  AdminSystem: 'admin_system',
  // Maintenance module
  MaintenanceDashboard: 'maintenance_dashboard',
  MaintenanceAssets: 'maintenance_assets',
  MaintenanceRules: 'maintenance_rules',
  MaintenanceInterventions: 'maintenance_interventions',
  MaintenanceReports: 'maintenance_reports',
  MaintenanceAdmin: 'maintenance_admin',
  // Camera streaming
  CamerasView: 'cameras_view',
  CamerasManage: 'cameras_manage',
  // Mosaic templates (TVCC layouts) — permessi globali (any-of-user-companies);
  // la visibilita' del singolo template e' filtrata server-side via company-intersection.
  MosaicTemplatesCreate: 'mosaic_templates_create',
  MosaicTemplatesEdit: 'mosaic_templates_edit',
  MosaicTemplatesDelete: 'mosaic_templates_delete',
  // Gateway Connect — accesso remoto a PLC/HMI/IPC tramite tunnel WG on-demand
  // Read = vede catalogo device + sessioni; ReadWrite = CRUD + apre/chiude finestre + kill switch
  RemoteAccess: 'remote_access',
  // Booleano effettivo (solo ReadWrite ha senso) — chi può aprire un tunnel
  RemoteAccessConnect: 'remote_access_connect',
} as const;
